// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"97d6536e","513":"83a2be73","703":"09c938df","787":"eaec6c61"}[chunkId] + ".chunk.js";
};